import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@spartacus/core';
import { CmsConfig, I18nModule, provideConfig, UrlModule, provideDefaultConfig} from "@spartacus/core";
import {
  FileUploadModule,
  FormErrorsModule,
  IconModule,
  KeyboardFocusModule,
  CardModule,
  ListNavigationModule,
  SpinnerModule,
} from '@spartacus/storefront';
import { ChatMessagingModule } from '@spartacus/storefront';

import { GonvarriCustomerTicketingFormComponent } from '../../components/gonvarri-customer-ticketing-form/gonvarri-customer-ticketing-form.component';
import { GonvarriCustomerTicketingDetailsComponent } from '../../components/gonvarri-customer-ticketing-details/gonvarri-customer-ticketing-details.component';

import { gonvarriDefaultCreatedTicketLayoutConfig } from "../../layouts/created-ticket-layout-config";
import { CustomerTicketingRootModule } from '@spartacus/customer-ticketing/root';

import { CustomerTicketingMessagesComponentService } from "../../components/gonvarri-customer-ticketing-messages/customer-ticketing-messages-component.service";
import { CustomerTicketingReopenComponentService } from "../../components/gonvarri-customer-ticketing-reopen/customer-ticketing-reopen-component.service";
import { CustomerTicketingCloseComponentService } from "../../components/gonvarri-customer-ticketing-close/customer-ticketing-close-component.service";
import { GonvarriCustomerTicketingCreateComponent } from '../../components/gonvarri-customer-ticketing-create/gonvarri-customer-ticketing-create.component';
import { GonvarriCustomerTicketingListComponent } from '../../components/gonvarri-customer-ticketing-list/gonvarri-customer-ticketing-list.component';
import { GonvarriCustomerTicketingMessagesComponent } from '../../components/gonvarri-customer-ticketing-messages/gonvarri-customer-ticketing-messages.component';
import { GonvarriCustomerTicketingReopenComponent } from '../../components/gonvarri-customer-ticketing-reopen/gonvarri-customer-ticketing-reopen.component';
import { CustomerTicketingReopenDialogComponent } from '../../components/gonvarri-customer-ticketing-reopen/customer-ticketing-reopen-dialog.component';
import { GonvarriCustomerTicketingCloseComponent } from '../../components/gonvarri-customer-ticketing-close/gonvarri-customer-ticketing-close.component';
import { CustomerTicketingCloseDialogComponent } from '../../components/gonvarri-customer-ticketing-close/customer-ticketing-close-dialog.component';
import { GonvarriCustomerTicketingService } from '../../core/services/gonvarri-customer-ticketing.service';

import { GonvarriCustomerTicketingAdapter } from '../../core/adapters/gonvarri-customer-ticketing.adapter';
import { GonvarriCustomerTicketingConnector } from '../../core/connectors/gonvarri-customer-ticketing.connector';

@NgModule({
  declarations: [
    GonvarriCustomerTicketingListComponent,
    GonvarriCustomerTicketingCreateComponent,
    GonvarriCustomerTicketingFormComponent,
    GonvarriCustomerTicketingCloseComponent,
    CustomerTicketingCloseDialogComponent,
    GonvarriCustomerTicketingDetailsComponent,
    GonvarriCustomerTicketingMessagesComponent,
    GonvarriCustomerTicketingReopenComponent,
    CustomerTicketingReopenDialogComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    KeyboardFocusModule,
    ReactiveFormsModule,
    FormErrorsModule,
    FileUploadModule,
    CommonModule, 
    I18nModule,
    UrlModule,
    CardModule,
    IconModule,
    ListNavigationModule,
    RouterModule,
    SpinnerModule,
    ChatMessagingModule,
    CustomerTicketingRootModule,
  ],
  exports: [
    GonvarriCustomerTicketingListComponent,
    GonvarriCustomerTicketingCreateComponent,
    GonvarriCustomerTicketingFormComponent,
    GonvarriCustomerTicketingCloseComponent,
    CustomerTicketingCloseDialogComponent,
    GonvarriCustomerTicketingDetailsComponent,
    GonvarriCustomerTicketingMessagesComponent,
    GonvarriCustomerTicketingReopenComponent,
    CustomerTicketingReopenDialogComponent,
  ],
  providers: [
      GonvarriCustomerTicketingService,
      GonvarriCustomerTicketingAdapter,
      GonvarriCustomerTicketingConnector,
      CustomerTicketingMessagesComponentService,
      CustomerTicketingReopenComponentService,
      CustomerTicketingCloseComponentService,

      provideConfig(<CmsConfig>{
        cmsComponents: {
          CustomerTicketingCreateComponent: {
            component: GonvarriCustomerTicketingCreateComponent
          },
          SupportTicketHistoryComponent: {
            component: GonvarriCustomerTicketingListComponent
          },
          SupportTicketCloseComponent: {
            component: GonvarriCustomerTicketingCloseComponent,
            guards: [AuthGuard],
          },
          SupportTicketDetailsComponent: {
            component: GonvarriCustomerTicketingDetailsComponent,
            guards: [AuthGuard],
          },
          SupportTicketUpdateComponent: {
            component: GonvarriCustomerTicketingMessagesComponent,
            guards: [AuthGuard],
          },
          SupportTicketReopenComponent: {
            component: GonvarriCustomerTicketingReopenComponent,
            guards: [AuthGuard],
          },
        }
      }),
      provideDefaultConfig(gonvarriDefaultCreatedTicketLayoutConfig),
    ]
})
export class GonvarriCustomerTicketingModule { }